import {Fragment, useContext} from 'react';
import PromotionCodeContext from '../../../store/promotion-code-context';

import BottleList from './BottleList/BottleList';
import PromoBanner from '../PromoBanner/PromoBanner';

import SectionHeader from '../TextElements/SectionHeader/SectionHeader';
import HeaderTagline from '../TextElements/HeaderTagline/HeaderTagline';

const Bottles = props => {

	const promoCodeCtx = useContext(PromotionCodeContext);

	// Default Copy
	let headerCopy = 'From Our Family to Your Table';
	let taglineCopy = `True Olive olive oils are crafted from our 400-acre family grove in the 
	Dardanelles, near the ancient city of Troy. More than a decade ago, a fire swept through 
	the land, over time, the forest floor renewed itself, as the fallen trees enriched the soil. 
	From this renewal, the olives returned stronger, carrying a depth and uniqueness that reflect 
	the heritage of our grove.`;

	//Custom Copy
	if (props.header) headerCopy = props.header;
	if (props.tagline) taglineCopy = props.tagline;				

	return (
		<Fragment>
			<div className='col-xl-10 py-5 mb-2'>
				<SectionHeader passOnClasses='mb-2'><em>{headerCopy}</em></SectionHeader>
				<HeaderTagline>{taglineCopy}</HeaderTagline>
			</div>
			<div className='col-12 text-center'>
				{!props.noDiscount && promoCodeCtx.couponId && <PromoBanner />}
			</div>
			<div className='col-12 mb-5'>
				<BottleList bottleList={props.bottlesArray} />
			</div>
		</Fragment>
	)
}

export default Bottles;